import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { RequestTypes } from '../requestTypes'
import { registerTemplateKeys } from '../registerTemplateKeys'
import {
  RegisterTemplate,
  IRegisterTemplate,
} from '@core/entities/register/RegisterTemplate'
import { PageResponse } from '@core/entities/pagination'
import { RequestErrorType } from '@core/utils/api-axios-instance'

const templatesTransform = (response: PageResponse<IRegisterTemplate>) => ({
  ...response,
  content: response.content.map((template) => RegisterTemplate.new(template)),
})
export const useGetRegisterTemplates = (
  payload: RequestTypes['getRegisterTemplates'],
  options?: UseQueryOptions<
    PageResponse<IRegisterTemplate>,
    RequestErrorType,
    PageResponse<RegisterTemplate>
  >,
) => {
  return useQuery({
    select: templatesTransform,
    ...registerTemplateKeys.byOrganisation(payload),
    ...options,
  })
}
